import axios, { AxiosError } from "axios";
import domain from './domen'
import { IRegForm, IRegResponsFunction } from "../Intarfaces/IReg";
import { IUser, IUserEdit, IUserEditResponsFunction, IUserResponsFunction } from "../Intarfaces/IUser";

const sleep = (ms:number) => new Promise(
    resolve => setTimeout(resolve, ms));

export default class UserApi{
    
    static async get():Promise<IUserResponsFunction>{
        
        try{
            const response = await axios.get(domain+'/me',{
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bearer ${localStorage.getItem("token")}`
                }
            })

            console.log(response.data);
            
    
            if(response.status===200){
                return {status:200, message:"True", user:{ ...response.data } as IUser, lesson_id:response.data.lesson_id} as IUserResponsFunction
            }

            return {status:response.status, message:"Ошибка", user:null, lesson_id:null} as IUserResponsFunction
        }
        catch(error){

            let er = error as AxiosError<{detail:string}>
            console.log(error);
            
            
            if(er.status===403 || er.status===401){
                localStorage.removeItem("token")
                window.location.reload();
                return {status:403, message:"Неверный E-mail или пароль"} as IUserResponsFunction
            }

            return {status:0, message:"Ошибка"} as IUserResponsFunction
            
        }
    }

    static async edit(form:IUserEdit, step:number):Promise<IUserEditResponsFunction>{
        
        try{
            const response = await axios.put(domain+'/me', {...form,lesson_id:step},{
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bearer ${localStorage.getItem("token")}`
                }
            })

            console.log(response.data);
            
    
            if(response.status===200){
                return {status:200, message:"Изменения успешно сохранены"} as IUserEditResponsFunction
            }

            return {status:response.status, message:"Ошибка"} as IUserEditResponsFunction
        }
        catch(error){

            let er = error as AxiosError<{detail:string}>
            console.log(error);
            
            
            if(er.status===403 || er.status===401){
                localStorage.removeItem("token")
                window.location.reload();
                return {status:403, message:"Неверный E-mail или пароль"} as IUserResponsFunction
            }

            return {status:0, message:"Ошибка"} as IUserEditResponsFunction
        }
    }

}